/* global window document pymChild */

import './styles/graphic.scss';
import * as axios from 'axios';
import { Child } from 'pym.js';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'regenerator-runtime/runtime';
import * as hashes from './data/hash-dict';
// import * as events_data from './data/data';

// ////// ENTER LOCAL FILE (for testing)
import * as maplocal from './data/latest';

// ////// TOGGLE FOR LOCAL/LIVE DATA
const use_live_data = true;

// ////// ENTER URL for data processed by cronbot
const map_data_url = 'https://ix.cnn.io/data/power-outages/latest.json';

// ////// ENTER details for map styles
const config = {
  style: 'mapbox://styles/cnndigital/ckwnwzluj0tm014l5zu5mnkrt',
  default_zoom: 3.5,
  default_lon: -0.4428283453226527,
  default_lat: -0.954846509517921,
};

// >> ENTER graphic slug, with date ... ie "20210908-stream-flood-tracker"
const graphic_slug = '20210923-power-outage-live';

const state_hashes = hashes.default;

// date
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('America/New_York');
dayjs.extend(updateLocale);
dayjs.updateLocale('en', {
  monthsShort: [
    'Jan.', 'Feb.', 'March', 'April', 'May', 'June',
    'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.',
  ],
  meridiem: (hour, minute, isLowercase) => (hour >= 12 ? 'p.m.' : 'a.m.'),
});

// Mapbox
const mapboxgl = require('mapbox-gl');

const MAPBOX_TOKEN = 'pk.eyJ1IjoiY25uZGlnaXRhbCIsImEiOiJja2V1M3Vyd3kwMDZrMnF0Njdhb3ZhZDk5In0.OURIYzTcS6ZzoWjXJzfANg';
const defaultCenter = [config.default_lon, config.default_lat];
let map;
let mapParams;
let hasLocation;
let usingParentDotHtml = false;
let outageEvent;


// instantiate pym object
window.pymChild = new Child();

// check for URL params
function checkParams(events) {
  // use the staging parent URL if we're in the CNN staging environment
  // otherwise use the straight url
  let url;
  if ((pymChild.parentUrl) && (pymChild.parentUrl.indexOf('/parent.html') !== -1)) {
    url = pymChild.parentUrl;
    usingParentDotHtml = true;
  } else {
    url = window.location.href;
  }

  console.log('Parent url:', pymChild.parentUrl);
  console.log('Using url:', url);

  // Parse params
  const getParams = function (url) {
    const params = {};
    const parser = document.createElement('a');
    parser.href = url;
    const query = parser.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
  };

  const splitMbhash = (text) => {
    let hasharray = [];
    hasharray = text.split('/').map(Number);

    // return the bearing as 0 if it's missing
    if (hasharray.length == 3) {
      hasharray[3] = 0;
    }
    return hasharray;
  };


  mapParams = getParams(url);
  if ('lnglat' in mapParams) {
    mapParams.lnglat = [parseFloat(mapParams.lnglat.split(',')[0]), parseFloat(mapParams.lnglat.split(',')[1])];
  }
  if ('z' in mapParams) {
    mapParams.z = parseFloat(mapParams.z);
  }
  if ('bearing' in mapParams) {
    mapParams.bearing = parseFloat(mapParams.bearing);
  }
  if ('state' in mapParams) {
    mapParams.mbhash = state_hashes[mapParams.state.toUpperCase()];
    console.log('centered on ', mapParams.state.toUpperCase());
  }
  if ('event' in mapParams) {
    const find_event = events.filter(d => d.event_code == mapParams.event);

    if (find_event) {
      outageEvent = find_event[0];
    }

    if (outageEvent && outageEvent.map_view) {
      mapParams.mbhash = outageEvent.map_view;
      console.log('using event', mapParams.event);
    }
  }
  if ('mbhash' in mapParams) {
    const parsedHash = splitMbhash(mapParams.mbhash);
    mapParams.z = parsedHash[0];
    mapParams.lnglat = [parsedHash[2], parsedHash[1]];
    mapParams.bearing = parsedHash[3];
  }

  console.log('mapParams', mapParams);

  // Set params to true if they have what we want (zoom + lng/lat)
  hasLocation = !!('lnglat' in mapParams && 'z' in mapParams);
}

// main export function //

export default function (props, container, isMobile, meta) {
  // function to get the latest map data
  const fetchData = async (data_url) => {
    const response = await axios.get(data_url);
    return response.data;
  };

  // function to draw the map
  const drawMap = (mapdata) => {
    const {
      initialWidth,
      initialHeight,
      // width,
      // height
      data,
    } = props;

    // check url params, but also pass along the event data we have
    // from the spreadsheet via data.json
    checkParams(data);

    // // -- handle map's update time -- // //

    const as_of_time = {};

    as_of_time.display = dayjs(mapdata.as_of).tz('America/New_York').format('dddd, MMM D [at] h:mm a [ET]');

    // // -- dynamic headline -- // //

    const dynamic_meta = container
      .append('div')
      .attr('id', 'dynamic-meta')
      .html('');

    let { headline } = meta; // get headline from meta data

    if (outageEvent && outageEvent.headline) {
      headline = outageEvent.headline;
    }

    dynamic_meta
      .append('h1')
      .attr('class', 'headline')
      .html(headline);

    // // -- dynamic dek -- // //

    const dek_html = `Here are the areas without electricity as of ${as_of_time.display}.`;

    dynamic_meta
      .append('h2')
      .attr('class', 'dek')
      .html(dek_html);

    // // -- legend code -- // //

    const legend_title = 'Percent of customers without power';
    const color_width = 40; // width in pixels
    const breaks = ['10%', 20, 30, 40, 50, 60, 70, 80, '90%'];
    const colors = '#e6e6e6,#feca8d,#fd9668,#f1605d,#cd4071,#9e2f7f,#721f81,#440f76,#180f3d,#000004'.split(',');


    // assumes a previously-established container div
    container
      .append('div')
      .attr('class', 'v-legend-hed')
      .html(legend_title);

    const map_legend = container
      .append('div')
      .attr('class', 'v-legend-colors-container')
      .attr('width', initialWidth);

    map_legend.selectAll('.v-legend-colors')
      .data(colors)
      .enter()
      .append('div')
      .attr('class', 'v-legend-colors')
      .style('height', '8px')
      .style('width', `${color_width}px`)
      .style('background-color', d => d);

    const map_legend_labels = container
      .append('div')
      .attr('class', 'v-legend-labels-container')
      .attr('width', initialWidth);

    map_legend_labels
      .append('div')
      .attr('class', 'v-legend-label-spacer')
      .style('width', `${color_width / 2}px`);

    map_legend_labels.selectAll('.v-legend-labels')
      .data(breaks)
      .enter()
      .append('div')
      .attr('class', 'v-legend-labels')
      .style('width', `${color_width}px`)
      .html(d => d);

    map_legend_labels
      .append('div')
      .attr('class', 'v-legend-label-spacer')
      .style('width', `${color_width / 2}px`);

    // // -- Map drawing -- // //

    console.log('using cnnvis-cronbot data:', mapdata);

    function getZoom() {
      let zoomLevel;
      if (hasLocation) {
        zoomLevel = isMobile ? mapParams.z - 1 : mapParams.z;
      } else {
        zoomLevel = isMobile ? config.default_zoom - 1 : config.default_zoom;
      }
      return zoomLevel;
    }

    // Draw the map
    container.append('div')
      .attr('class', 'map-container')
      .append('div')
      .attr('id', 'map')
      .attr('width', initialWidth)
      .attr('height', initialHeight);

    mapboxgl.accessToken = MAPBOX_TOKEN;
    map = new mapboxgl.Map({
      container: 'map',
      center: hasLocation ? mapParams.lnglat : defaultCenter,
      style: config.style,
      zoom: getZoom(),
      bearing: ('bearing' in mapParams) ? mapParams.bearing : 0,
      bearingSnap: 0,
      maxZoom: 7,
      minZoom: 2,
      maxBounds: [[-37, -23], [32, 22]],
      pitchWithRotate: false,
      scrollZoom: false,
      dragRotate: false,
      touchPitch: false,
      interactive: true,
      hash: false,
    });


    console.log('ENV:', process.env.NODE_ENV);
    // zoom buttons
    const nav = new mapboxgl.NavigationControl({
      showCompass: false,
    });
    map.addControl(nav, 'top-right');

    // ////// LOAD YOUR DATA GEOJSON HERE /////////

    map.on('load', () => {
      map.addSource('countydata', {
        type: 'geojson',
        data: mapdata,
      });

      map.addLayer({
        id: 'countydata',
        source: 'countydata',
        type: 'fill',
        paint: {
          'fill-color': ['get', 'fill'],
          'fill-opacity': 1,
        },

        // type: 'circle',
        // paint: {
        //   'circle-color': ['get', 'fill'],
        //   'circle-radius': 6,
        //   'circle-opacity': 0.9,
        // },

      // Layer in the style stack under which this layer should be drawn
      // (We're using 'state-boundaries, which is below all the state and city names)
      }, 'state-innerlines');
      // }, 'jk-albers-us-state-labels-v1');
    });

    // reorient to north if we zoom out past original zoom set
    map.on('zoomend', () => {
      if (mapParams.z && map.getZoom() < mapParams.z) {
        map.rotateTo(0, { duration: 500 });
      }
    });

    map.on('moveend', () => {
      // /////// THIS PUTS EMBED CODES INTO THE CONSOLE LOG ////////
      // Note that these are removed in the
      console.log('- - - - - - - - - -');
      const current_lon = map.getCenter().lng.toPrecision(5);
      const current_lat = map.getCenter().lat.toPrecision(5);
      const current_zoom = map.getZoom().toPrecision(3);
      const current_bearing = map.getBearing().toPrecision(4);
      let new_params = `?lnglat=${current_lon},${current_lat}&z=${current_zoom}&bearing=${current_bearing}`;
      if (mapParams.event) {
        new_params = `?event=${mapParams.event}`;
      }
      console.log('DLE link:');
      console.log(`https://ix.cnn.io/dailygraphics/graphics/${graphic_slug}/index.html${new_params}`);
      console.log('Web tag:');
      console.log(`<div id="responsive-embed-${graphic_slug}"></div><script>if(!window.pym){(function(b,c){var d=document.createElement("script");d.type="text/javascript",d.readyState?d.onreadystatechange=function(){("loaded"===d.readyState||"complete"===d.readyState)&&(d.onreadystatechange=null,c())}:d.onload=function(){c()},d.src=b,document.getElementsByTagName("head")[0].appendChild(d)})("//cdn.cnn.com/cnn/.e/interactive/js/lib/vendor/pym/pym.v1.min.js",function(){new pym.Parent("responsive-embed-${graphic_slug}","//ix.cnn.io/dailygraphics/graphics/${graphic_slug}/index.html${new_params}",{title:"CNN Graphic"})})}else var responsiveEmbed=new pym.Parent("responsive-embed-${graphic_slug}","//ix.cnn.io/dailygraphics/graphics/${graphic_slug}/index.html${new_params}",{title:"CNN Graphic"});
</script>`);
      console.log('map_view:');
      console.log(`${current_zoom}/${current_lat}/${current_lon}/${current_bearing}  (zoom/fakelat/fakelon/bearing)`);
    });

    // update height of svg to pym
    pymChild.sendHeight();
  };

  if (use_live_data) {
    // fetch data and draw the map
    fetchData(map_data_url).then(drawMap);
  } else {
    // LOCAL TESTING
    console.log(maplocal);
    drawMap(maplocal.default);
  }
}
